/**
 * @param {*} raw
 * @return {{label: string, downloadUrl: string, size: number}}
 */
export const attachment = (raw) => ({
  label: raw.label ? raw.label : '',
  downloadUrl: raw.downloadUrl ? raw.downloadUrl : '',
  size: raw.size ? parseInt(raw.size, 10) : 0,
});
